'use strict';
vendorPayments1099Controller.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'dialogHelper',
	'reportHelper',
	'authService',
	'fm1099Service',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('vendorPayments1099Controller', vendorPayments1099Controller);

function vendorPayments1099Controller(
	$scope,
	$rootScope,
	$q,
	$interval,
	dialogHelper,
	reportHelper,
	authService,
	fm1099Service,
	USER_CLAIMS,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromise = $q.all([$scope.vm.loadConfigInfo($scope.vm)]);

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			message: BUSY_MESSAGE.Loading,
			configuredYears: [],
			selectedTaxYear: null,
			isPayrollAccessible: false,
		};

		function loadConfigInfo(model) {
			return fm1099Service.getTaxYears().then(_.partial(finishedLoadingConfig, model));

			function finishedLoadingConfig(model, response) {
				if (response.data.isValid) {
					model.configuredYears = response.data.taxYears;

					var currentYear = new Date().getFullYear();
					if (
						_.filter(model.configuredYears, function (year) {
							return year === currentYear;
						}).length > 0
					) {
						model.selectedTaxYear = currentYear;
					} else {
						model.selectedTaxYear = model.configuredYears[0];
					}
				} else {
					model.errors = response.data.errors;
				}
			}
		}

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (_.isNull(model.selectedTaxYear)) {
				model.validationErrors.push("Please select a 'Tax Year'.");
				isValid = false;
			}

			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Vendor Payments Report Error!', null, model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromiseMain = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var param = {
				Year: model.selectedTaxYear,
			};

			reportHelper.postReport($scope, '/api/fundreports/vendorpayments1099report', param, '1099VendorPaymentsReport.pdf');
		}

		function exportExcel(model) {
			if (!validateReportParams(model)) {
				$scope.isReportFinished = true;
				dialogHelper.openMessageBox('1099 Vendor Payments Excel Error!', null, model.validationErrors);
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromiseMain = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var param = {
				Year: model.selectedTaxYear,
			};

			reportHelper.postExcel($scope, '/api/fundreports/vendorpayments1099excel', param, '1099VendorPayments.xlsx');
		}

		return angular.extend(model, {
			loadConfigInfo: _.partial(loadConfigInfo, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}
}
